"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuButton = MenuButton;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function MenuButton() {
  var anchorRef = (0, _react.useRef)(null);
  var layoutContext = (0, _react.useContext)(_core.LayoutContext);
  return /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    ref: anchorRef,
    "aria-haspopup": "true",
    size: "small",
    color: "inherit",
    onClick: layoutContext.toggleDrawer,
    sx: function sx(theme) {
      return {
        display: {
          xs: 'flex'
        },
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(-1.5)
      };
    }
  }, /*#__PURE__*/_react["default"].createElement(_commons.MenuIcon, null));
}